module.exports = __webpack_public_path__ + "static/media/checkInfluencer.9612a12e.svg";